export default __webpack_public_path__ + "static/national-metric-desktop-566417fd88c8617abe026714d434c180.svg";